import { render, staticRenderFns } from "./IntegrationFormPagerduty.vue?vue&type=template&id=2b25fe04&scoped=true"
import script from "./IntegrationFormPagerduty.vue?vue&type=script&lang=js"
export * from "./IntegrationFormPagerduty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b25fe04",
  null
  
)

export default component.exports